import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('../components/Login.vue'),
    },
    {
        path: '/404',
        name: '404',
        meta: { title: '404' },
        component: () => import('../components/404.vue'),
    },
    { path: '/', redirect: '/home' },
]

const commonRoutes2 = [
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('../components/Login.vue'),
    },
    {
        path: '/404',
        name: '404',
        meta: { title: '404' },
        component: () => import('../components/404.vue'),
    },
    { path: '/', redirect: '/distributeaccount' },
]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    home: {
        path: 'home',
        name: 'home',
        meta: { title: '主页' },
        component: () => import('../views/Home.vue'),
    },
    realtimedata: {
        path: 'realtimedata',
        name: 'realtimedata',
        meta: { title: '实时数据' },
        component: () => import('../views/RealtimeData.vue'),
    },
    t1: {
        path: 't1',
        name: 't1',
        meta: { title: '表格' },
        component: () => import('../views/T1.vue'),
    },
    password: {
        path: 'password',
        name: 'password',
        meta: { title: '修改密码' },
        component: () => import('../views/Password.vue'),
    },
    msg: {
        path: 'msg',
        name: 'msg',
        meta: { title: '通知消息' },
        component: () => import('../views/Msg.vue'),
    },
    userinfo: {
        path: 'userinfo',
        name: 'userinfo',
        meta: { title: '用户信息' },
        component: () => import('../views/UserInfo.vue'),
    },
    downmessage: {
        path: 'downmessage',
        name: 'downmessage',
        meta: { title: '参数下发' },
        component: () => import('../views/DownMessage.vue'),
    },
    1: {
        path: '/404',
        name: '1',
        meta: { title: '1' },
        component: () => import('../components/404.vue'),
    },
    2: {
        path: '/404',
        name: '2',
        meta: { title: '2' },
        component: () => import('../components/404.vue'),
    },
    3: {
        path: '/404',
        name: '3',
        meta: { title: '3' },
        component: () => import('../components/404.vue'),
    },
    4: {
        path: '/404',
        name: '4',
        meta: { title: '4' },
        component: () => import('../components/404.vue'),
    },
    settlement: {
        path: '/settlement',
        name: 'settlement',
        meta: { title: '结算数据' },
        component: () => import('../views/Settlement.vue'),
    },
    warn: {
        path: '/warn',
        name: 'warn',
        meta: { title: '监控报警' },
        component: () => import('../views/Warn.vue'),
    },
    historydata: {
        path: '/historydata',
        name: 'historydata',
        meta: { title: '历史数据' },
        component: () => import('../views/HistoryData.vue'),
    },
    meter: {
        path: '/meter',
        name: 'meter',
        meta: { title: '设备管理' },
        component: () => import('../views/Meter.vue'),
    },
    account: {
        path: '/account',
        name: 'account',
        meta: { title: '账号管理' },
        component: () => import('../views/Account.vue'),
    },
    distributeaccount: {
        path: '/distributeaccount',
        name: 'distributeaccount',
        meta: { title: '主页' },
        // component: () => import('../views/DistributeAccount.vue'),
        component: () => import('../views/T1.vue'),
    },
    distributeaccountSL: {
        path: '/distributeaccountSL',
        name: 'distributeaccountSL',
        meta: { title: '水表（流量计）' },
        component: () => import('../views/DistributeAccountSL.vue'),
    },
    distributeaccountL: {
        path: '/distributeaccountL',
        name: 'distributeaccountL',
        meta: { title: '流量计' },
        component: () => import('../views/DistributeAccountL.vue'),
    },
    distributeaccountR: {
        path: '/distributeaccountR',
        name: 'distributeaccountR',
        meta: { title: '热量表' },
        component: () => import('../views/DistributeAccountR.vue'),
    },
    factoryversion: {
        path: '/factoryversion',
        name: 'factoryversion',
        meta: { title: '表具出厂信息' },
        component: () => import('../views/FactoryVersion.vue'),
    },
    lastmessage: {
        path: '/lastmessage',
        name: 'lastmessage',
        meta: { title: '表具最新数据' },
        component: () => import('../views/LastMessage.vue'),
    },
    meterreading: {
        path: '/meterreading',
        name: 'meterreading',
        meta: { title: '上报成功率' },
        component: () => import('../views/MeterReading.vue'),
    },
    communicationsuccessrate: {
        path: '/communicationsuccessrate',
        name: 'communicationsuccessrate',
        meta: { title: '抄表成功率' },
        component: () => import('../views/CommunicationSuccessRate.vue'),
    },
    faultalarm: {
        path: '/faultalarm',
        name: 'faultalarm',
        meta: { title: '故障报警' },
        component: () => import('../views/FaultAlarm.vue'),
    },
    downsetting: {
        path: '/downsetting',
        name: 'downsetting',
        meta: { title: '通信参数设置' },
        component: () => import('../views/DownSetting.vue'),
    },
    meterreadingfailure: {
        path: '/meterreadingfailure',
        name: 'meterreadingfailure',
        meta: { title: '抄表失败' },
        component: () => import('../views/MeterReadingFailure.vue'),
    },
    meterreadingfailure2: {
        path: '/meterreadingfailure2',
        name: 'meterreadingfailure2',
        meta: { title: '抄表失败' },
        component: () => import('../views/MeterReadingFailure2.vue'),
    }
}

var createRouter = () => new Router({
    routes: commonRoutes,
})

// const createRouter = function(){
//     if(localStorage.getItem('userAuth') == 0){
//         return new Router({
//             routes: commonRoutes2
//         })
//     }else{
//         return new Router({
//             routes: commonRoutes
//         })
//     }
// }

var router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export function reLoadRouter() {
    router = new Router({
        routes: commonRoutes2
    })
}

export default router